
<template>
  <v-app id="templates">
    <v-main>
      <v-container fluid>  
            <v-card flat>
                <v-card-title class="justify-center">{{this.title}} ({{ this.watp_doelgroep }})</v-card-title>
                <v-divider class="mb-2"/>
                <v-simple-table dense v-if="templates.length > 0">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Characters</th>
                            <th>Language</th>
                            <th>Text</th>
                        </tr>
                    </thead>
                    <tbody v-for="(template, i) in templates" :key="i">
                        <tr :class="{'color': i%2!==0}">
                            <td style="width: 500px;">{{ template.watp_code }}</td>
                            <td>{{ template.watp_chars }}</td>
                            <td>{{ template.watp_taalcode }}</td>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" icon v-on:click="$router.reload('/syst/watp/onWatp/' + template.watp_encrid)">
                                            <v-icon>mdi-file-document-edit-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edit templates</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </tbody>  
                </v-simple-table>  
                <div v-else class="mt-10" style="display:flex; flex-direction: row; justify-content: center;">No data found</div>
            </v-card>  
        </v-container>
    </v-main>
    <navBar title="Ares - Templates" :home="true" type="mltp"/>   
  </v-app>
</template>


<script>
 import navBar from "@/components/ui/navbars/navbar.vue"
 export default {
  components: {
    navBar
  },
  props: ['watp_doelgroep'],
  watch: { 
    watp_doelgroep: function() { // watch it
        this.getData();
    }
  },
  data() {
    return {
      templates: [],
      title: "Whatsapp template overview"
    }  
  },
  mounted() { 
      this.getData();
  },
  methods: {
       getData() {
         this.$axios
        .post("ares/json/ares/syst/watp/searchWatp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchWatp"
          },
          searchWatp: {            
            watp_doelgroep: this.watp_doelgroep
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.templates = res.data.searchWatp;
          }
        })
       }
    }
};

</script> 

<style scoped>
.color {
    background-color: #faf8f8;
}
</style>